import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { showErrors } from '@/utils/snack';
import { queryAreas } from '@/views/SchoolList/gql';

var GetAllDistricts = /*#__PURE__*/function (_Vue) {
  _inherits(GetAllDistricts, _Vue);

  var _super = _createSuper(GetAllDistricts);

  function GetAllDistricts() {
    var _this;

    _classCallCheck(this, GetAllDistricts);

    _this = _super.apply(this, arguments);
    _this.areas = [];
    _this.provinces = [];
    _this.cities = [];
    _this.regions = [];
    _this.provinceOptions = [];
    _this.cityOptions = [];
    _this.regionOptions = [];
    _this.schoolOptions = [];
    _this.yearOptions = [];
    _this.classesOptions = [];
    return _this;
  }

  _createClass(GetAllDistricts, [{
    key: "getProvinces",
    value: function () {
      var _getProvinces = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.query({
                  query: queryAreas,
                  variables: {
                    parentId: 1
                  }
                });

              case 3:
                result = _context.sent;
                this.provinces = result.data.queryAreas;
                this.provinceOptions = this.provinces.map(function (item) {
                  return item.name;
                });
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function getProvinces() {
        return _getProvinces.apply(this, arguments);
      }

      return getProvinces;
    }()
  }, {
    key: "getCities",
    value: function () {
      var _getCities = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(provinceId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: queryAreas,
                  variables: {
                    parentId: provinceId
                  }
                });

              case 3:
                result = _context2.sent;
                this.cities = result.data.queryAreas;
                this.cityOptions = this.cities.map(function (item) {
                  return item.name;
                });
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getCities(_x) {
        return _getCities.apply(this, arguments);
      }

      return getCities;
    }()
  }, {
    key: "getRegions",
    value: function () {
      var _getRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cityId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: queryAreas,
                  variables: {
                    parentId: cityId
                  }
                });

              case 3:
                result = _context3.sent;
                this.regions = result.data.queryAreas;
                this.regionOptions = this.regions.map(function (item) {
                  return item.name;
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function getRegions(_x2) {
        return _getRegions.apply(this, arguments);
      }

      return getRegions;
    }()
  }]);

  return GetAllDistricts;
}(Vue);

GetAllDistricts = __decorate([Component], GetAllDistricts);
export default GetAllDistricts;